$(document).ready(function(){
    $('#table-returns-store').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-returns",
        'order': [[ 0, "desc" ]],
        "columns": [
            {data: 'id'},
            {data: 'supplier_name'},
            {data: 'reference'},
            {data: 'user_text'},
            {
                data: 'created_at',
                render: function (data, type, row) {
                    let date = new Date(data);
                    let dia = String(date.getDate()).padStart(2, '0');
                    let mes = String(date.getMonth() + 1).padStart(2, '0');
                    let anio = date.getFullYear();
                    return `${dia}-${mes}-${anio}`;
                }
            },
            {data: 'Estado',
                render: function (data, type, row) {
                    if(row.status == "A"){
                        return 'Activo'
                    }else if(row.status == "F"){
                        return 'Finalizado'
                    }
                }
            },

        ],
        "columnDefs": [
            {
                "targets": 6,
                "render": function (data, type, row, meta) {
                    return `<a href="/almacen/devoluciones/detalle/${row.uuid}"
               class="btn btn-primary btn-sm"
               data-toggle="tooltip"
               data-placement="top"
               title="Visualizar detalle">
               <i class="fas fa-list"></i>
            </a>` + getStatusForReturn(row);
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });

    $("#table-returns-store tbody").on("click", ".complete-transfer", function (e) {
        e.preventDefault();
        let data = new FormData();
        data.append('id', $(this).data('id'))
        data.append('uuid', $(this).data('uuid'))

        Swal.fire({
            title: '¿ Estas seguro ?',
            text: "¿ Deseas finalizar esta devolución ?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: "/complete-transfer",
                    type: "POST",
                    data: data,
                    processData: false,
                    contentType: false,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    beforeSend: function () {
                        //No deshabilitamos ningun boton
                    },
                    success: function (response) {
                        console.log(response);
                        if (response.success) {
                            alertSuccess(response.message)
                            $("#table-returns-store").DataTable().ajax.reload();
                        }else {
                            alertError(response.message)
                        }
                    },
                    error: function (xhr) {
                        console.log(xhr);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrió un error al procesar la solicitud'
                        });
                    },
                    complete: function () {
                        //No deshabilitamos ningun boton
                    }
                });
            }

        })

    })

    function getStatusForReturn(row)
    {
        if (row.status == "A") {
            return '<button data-toggle="tooltip" data-placement="top" title="Finalizar" ' +
                'class="btn btn-secondary complete-transfer btn-sm m-1"' +
                'data-row  ="' + row + '"' +
                'data-id   ="' + row.id + '"' +
                'data-uuid ="' + row.uuid + '">' +
                '<i class="fa-solid fa-check-double"></i>' +
                '</button>'
        }
        return ''
    }

})
